import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import { InputLabeledContainer, SingleDatePicker, TextInput } from 'tennders-common/form/components'
import { INPUT_CHARACTER_LIMITS } from 'tennders-stracture/libs/constants'

const OrderNo = (props) => {
  const { t } = useTranslation()
  const {
    form,
    errors,
    onChange,
    isOrderNoDisabled
  } = props
  const box_name = process.env.NEXT_PUBLIC_BOX_NAME

  return (
    <>
      <h4 className="bold">{t('document:orderNo')}</h4>
      <div className="d-flex mb-24">
        <InputLabeledContainer
          name="orderNumber"
          label={t('document:tenndersOrderNo', { box_name: box_name || '' })}
          className="mr-16"
          form={form}
          errors={errors}
          onChange={onChange}
          disabled={isOrderNoDisabled}
          required
          renderInput={(rest) => <TextInput maxLength={INPUT_CHARACTER_LIMITS.ORDER_NO} placeholder="XXXXXX" {...rest} />}
        />
        <InputLabeledContainer
          name="orderDate"
          label={t('document:order_date')}
          className="mr-16"
          form={form}
          errors={errors}
          onChange={onChange}
          required
          renderInput={(rest) => <SingleDatePicker {...rest} />}
        />
      </div>
    </>
  )
}

export default React.memo(OrderNo)
